module.exports = __webpack_public_path__ + "static/media/drag.b17c0ec9.svg";